import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { describeLeadsSummary } from '../leadsConfig';
import { leadsSummaryClearButtonSx, leadsSummaryRowSx, leadsSummaryTextSx } from './leadsUi.styles';

/**
 * Resumen del índice de Leads, a la izquierda de “Ordenar por”.
 * Sin filtros: total + consultas sin ver. Con filtros: “X de N leads · filtro” + Limpiar.
 * Map: docs/maps/leads.md (§ Índice).
 *
 * @param {{ total: number, visible: number, visibleIsLowerBound?: boolean,
 *   unseenInquiries?: number, filterLabels?: string[], onClear: () => void }} props
 */
export default function LeadsSummary({
  total,
  visible,
  visibleIsLowerBound = false,
  unseenInquiries = 0,
  filterLabels = [],
  onClear,
}) {
  const { filtered, text } = describeLeadsSummary({
    total,
    visible,
    visibleIsLowerBound,
    unseenInquiries,
    filterLabels,
  });
  return (
    <Box sx={leadsSummaryRowSx} data-testid="leads-summary">
      <Typography component="span" sx={leadsSummaryTextSx} title={text} aria-live="polite">
        {text}
      </Typography>
      {filtered && (
        <Button size="small" onClick={onClear} sx={leadsSummaryClearButtonSx} aria-label="Limpiar filtros">
          Limpiar
        </Button>
      )}
    </Box>
  );
}
